import React from 'react'
import Account from './Account'
import Notifications from './Notifications'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function TopBarDisplayTitleNoLocationSelect(props) {
  return (
    <div className="py-5 px-6 border-b border-slate-200 flex items-center justify-between">
      <div className="flex items-center space-x-8">
        {props.showBackButton ? (
          <div
            className="flex items-center space-x-2 cursor-pointer text-slate-900 hover:text-slate-700"
            onClick={props.onBackClick}
          >
            <div className="w-9 h-9 rounded-full flex items-center justify-center transition duration-150">
              <ArrowBackIcon />
            </div>
            <h2 className="text-xl">{props.title}</h2>
          </div>
        ) : (
          <h2 className="text-2xl text-slate-900">{props.title}</h2>
        )}
        {props.titleExtra || null}
      </div>
      <div className="flex">
        <div className="cursor-pointer">
          <Account />
        </div>
      </div>
    </div>
  )
}

export default TopBarDisplayTitleNoLocationSelect
